import React, { useCallback, useEffect, useState } from "react";
import "../DispensationManagement.css";
import Loader from "../../../components/Loader";
import { CreateHandleUnsaveNavigation } from "../../../utilities/handleUnsaveNavigation";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Box,
  Dialog,
  DialogActions,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigationGuard } from "../../../context/NavigationGuardProvider ";
import { useLocation, useNavigate } from "react-router-dom";
import StyledGridComp from "../../../components/StyledGridComp";
import SearchedComponent from "../../../components/SearchedComponent";
import {
  createDispensationDetailService,
  deleteDispensationDetailService,
  fetchAllDispensationDetailsService,
  fetchLoadingDataForDispensationDetailService,
} from "../../../services/dispensationManagementService";
import SearchableSelect from "../../../components/SearchableSelect";
import { notifyError, notifySuccess } from "../../../utilities/helper";
import { DeleteOutlineOutlined } from "@mui/icons-material";

const AddUpdateDispensationDetail = () => {
  const [load, setLoad] = useState(false);
  const [mainLoad, setMainLoad] = useState(false);
  const [name, setName] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchedValue, setSearchedValue] = useState("");
  const [loadingData, setLoadingData] = useState({
    doseLevelData: [],
    drugTypeData: [],
  });
  const [deletedId, setDeletedId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const dispesationDetailCreateSchema = yup.object().shape({
    doseLevel: yup.string().required("Dose Level is required"),
    drugType: yup.string().required("Drug Type is required"),
    quantity: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Quantity is not valid.")
      .required("Quantity is required"),
    doNotDispenseDays: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Do not dispense days is not valid.")
      .required("Do not dispense days is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(dispesationDetailCreateSchema),
    defaultValues: {
      doseLevel: "",
      drugType: "",
      quantity: "",
      doNotDispenseDays: "",
    },
  });
  const id = useLocation()?.state?.id;
  const visitName = useLocation()?.state?.name;
  const access_token = localStorage.getItem("access_token");

  const navigate = useNavigate();

  useNavigationGuard(isDirty);

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();

  useEffect(() => {
    if (access_token && id) {
      getDispensationDetailLoadData(access_token, id);
    }
  }, [access_token, id]);

  useEffect(() => {
    if (visitName) {
      setName(visitName);
    }
  }, [visitName]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchedValue);
    }, 100);
    return () => clearTimeout(timeout);
  }, [searchedValue]);

  useEffect(() => {
    if (page >= 0 && pageSize && access_token && id) {
      getDispensationDetailsData(
        access_token,
        id,
        page,
        pageSize,
        debouncedSearch
      );
    }
  }, [access_token, id, page, pageSize, debouncedSearch]);

  const { doseLevelData, drugTypeData } = loadingData;

  const columns = [
    {
      field: "dosageLevelName",
      headerName: "Dose Level",
      width: 280,
      renderHeader: () => <div className="grid-heading">{"Dose Level"}</div>,
      renderCell: (params) => {
        const dosageLevelName = params.row.dosageLevelName;

        return <span className="data-font">{dosageLevelName}</span>;
      },
    },
    {
      field: "drugTypeName",
      headerName: "Drug Type",
      width: 280,
      renderHeader: () => <div className="grid-heading">{"Drug Type"}</div>,
      renderCell: (params) => {
        const drugTypeName = params.row.drugTypeName;

        return <span className="data-font">{drugTypeName}</span>;
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 280,
      renderHeader: () => <div className="grid-heading">{"Quantity"}</div>,
      renderCell: (params) => {
        const quantity = params.row.quantity;

        return <span className="data-font">{quantity}</span>;
      },
    },
    {
      field: "doNotDispenseDays",
      headerName: "Do Not Dispense Days",
      width: 280,
      renderHeader: () => (
        <div className="grid-heading">{"Do Not Dispense Days"}</div>
      ),
      renderCell: (params) => {
        const doNotDispenseDays = params.row.doNotDispenseDays;

        return <span className="data-font">{doNotDispenseDays}</span>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 280,
      renderHeader: () => <div className="grid-heading">{"Action"}</div>,
      renderCell: (params) => {
        const id = params.row.id;

        return (
          <>
            <button
              className="grid-edit-btn"
              style={{ background: "red" }}
              onClick={() => {
                setShowConfirmModal(true);
                setDeletedId(id);
              }}
            >
              <DeleteOutlineOutlined sx={{ color: "white" }} />
            </button>
          </>
        );
      },
    },
  ];

  const getDispensationDetailsData = async (
    access_token,
    id,
    page,
    pageSize,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllDispensationDetailsService(
        access_token,
        id,
        page + 1,
        pageSize,
        debouncedSearch
      );
      if (res?.status == 200) {
        setLoad(false);
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
      } else if (res?.status == 401) {
        setLoad(false);
        navigate("/unauthorize");
      }
    } catch (err) {
      console.log(err?.message);
      setLoad(false);

      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  const getDispensationDetailLoadData = async (access_token, id) => {
    setMainLoad(true);
    try {
      const res = await fetchLoadingDataForDispensationDetailService(
        access_token,
        id
      );
      if (res?.data?.status == 200) {
        setMainLoad(false);
        setLoadingData({
          doseLevelData: res?.data?.result?.dosageLevelData,
          drugTypeData: res?.data?.result?.drugTypeData,
        });
      }
    } catch (err) {
      console.log(err?.message);
      setMainLoad(false);

      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  const addUpdateDispensationDetail = async (data) => {
    setMainLoad(true);
    const newData = {
      dispensationId: id,
      drugTypeId: data?.drugType,
      dosageLevelId: data?.doseLevel,
      quantity: data?.quantity,
      doNotDispenseDays: data?.doNotDispenseDays,
    };
    try {
      const res = await createDispensationDetailService(access_token, newData);
      if (res?.status == 200) {
        setMainLoad(false);
        reset();
        notifySuccess("Dispensation detail added successfully");
        getDispensationDetailsData(
          access_token,
          id,
          page,
          pageSize,
          debouncedSearch
        );
      }
    } catch (err) {
      setMainLoad(false);
      notifyError(err?.message || "Failed to add dispensation detail");
      console.log(err?.message);
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = useCallback((e) => {
    setSearchedValue(e.target.value);
  }, []);

  const handleDelete = async () => {
    try {
      setMainLoad(true);
      const res = await deleteDispensationDetailService(
        access_token,
        deletedId
      );
      if (res?.status == 200) {
        setMainLoad(false);
        setDeletedId(null);
        setShowConfirmModal(false);
        notifySuccess("Dispensation detail deleted successfully");
        getDispensationDetailsData(
          access_token,
          id,
          page,
          pageSize,
          debouncedSearch
        );
      }
    } catch (err) {
      setMainLoad(false);
      console.log(err?.message);
      setShowConfirmModal(false);
      setDeletedId(null);
      notifyError(err?.message || "Failed to delete dispensation detail");
      if (err?.status === 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <>
      {mainLoad ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button
              className="bread-crumbs-btn"
              onClick={(e) => handleUnsaveNavigation(e, isDirty, "", navigate)}
            >
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                handleUnsaveNavigation(
                  e,
                  isDirty,
                  "dispensation-management",
                  navigate
                )
              }
            >
              Dispensation Management
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                handleUnsaveNavigation(
                  e,
                  isDirty,
                  "dispensation-management",
                  navigate
                )
              }
            >
              {name}
            </button>{" "}
            |{" "}
            <button className="bread-crumbs-btn" to="/add-dispensation-detail">
              Dispensation Detail
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <div className="">
            <div className="">
              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={12}>
                  <p className="page-heading">Create</p>
                  <span className="sub-heading">Disepensation Detail</span>
                </Grid2>
              </Grid2>

              <Box
                component="form"
                autoComplete="off"
                sx={{ height: "auto", width: "100%" }}
                onSubmit={handleSubmit(addUpdateDispensationDetail)}
              >
                <Grid2
                  container
                  alignItems="center"
                  justifyContent={"space-between"}
                  sx={{ width: "100%", margin: "0 auto" }}
                  gap={1}
                >
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Dose Level
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={doseLevelData}
                        name={"doseLevel"}
                        optionKey="id"
                        optionLabel="name"
                      />
                    </div>
                    {errors.doseLevel && (
                      <div className="error-container">
                        {errors.doseLevel.message}
                      </div>
                    )}
                  </Grid2>{" "}
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Drug Type
                        <span>*</span>
                      </p>
                      <SearchableSelect
                        control={control}
                        data={drugTypeData}
                        name={"drugType"}
                        optionKey="id"
                        optionLabel="name"
                      />
                    </div>
                    {errors.drugType && (
                      <div className="error-container">
                        {errors.drugType.message}
                      </div>
                    )}
                  </Grid2>
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Quantity
                        <span>*</span>
                      </p>
                      <Controller
                        name="quantity"
                        control={control}
                        defaultValue="" // or an initial numeric string like "0"
                        render={({ field }) => (
                          <TextField
                            fullWidth
                            size="small"
                            type="text"
                            value={field.value}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                              if (value !== "0")
                                value = value.replace(/^0+/, ""); // Remove leading zeros

                              // Limit to 9 digits (i.e., max 999999999)
                              if (value.length > 9) value = value.slice(0, 9);
                              field.onChange(value); // Update form value
                            }}
                          />
                        )}
                      />
                    </div>
                    {errors.quantity && (
                      <div className="error-container">
                        {errors.quantity.message}
                      </div>
                    )}
                  </Grid2>
                  <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                    <div>
                      <p className="labelStyles">
                        Do Not Dispense Days
                        <span>*</span>
                      </p>
                      <Controller
                        name="doNotDispenseDays"
                        control={control}
                        defaultValue="" // or an initial numeric string like "0"
                        render={({ field }) => (
                          <TextField
                            fullWidth
                            size="small"
                            type="text"
                            value={field.value}
                            onChange={(e) => {
                              let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                              if (value !== "0")
                                value = value.replace(/^0+/, ""); // Remove leading zeros

                              // Limit to 9 digits (i.e., max 999999999)
                              if (value.length > 9) value = value.slice(0, 9);

                              field.onChange(value); // Update form value
                            }}
                          />
                        )}
                      />
                    </div>
                    {errors.doNotDispenseDays && (
                      <div className="error-container">
                        {errors.doNotDispenseDays.message}
                      </div>
                    )}
                  </Grid2>
                </Grid2>

                <Grid2
                  alignItems={"end"}
                  justifyContent="end"
                  container
                  gap={3}
                  sx={{ marginTop: "2%" }}
                >
                  <Grid2 item md={6}>
                    <button
                      type="button"
                      className="create-btn-outlined"
                      onClick={(e) => {
                        e.preventDefault();
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "dispensation-management",
                          navigate
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </Grid2>
                  <Grid2 item md={6}>
                    {/* {checkCanUpdate(id, isReadOnly, role) && ( */}
                    <button
                      type="submit"
                      // disabled={isReadOnly}
                      className={
                        // isReadOnly ? "disabled-btn" :
                        "create-btn"
                      }
                    >
                      Add
                    </button>
                    {/* )} */}
                  </Grid2>
                </Grid2>
              </Box>
            </div>
            <div className="">
              <Grid2
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%", margin: "0 auto" }}
              >
                <Grid2 item md={12}>
                  <p className="page-heading">Dispensation Details</p>
                  <span className="sub-heading">{name}</span>
                </Grid2>
              </Grid2>

              <Grid2 item md={6}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    margin: "10px 0px",
                    justifyContent: "end",
                  }}
                >
                  <SearchedComponent
                    handleSearch={handleSearch}
                    placeholder="Dispensation Detail"
                    searchedValue={searchedValue}
                  />
                </div>
              </Grid2>

              {load ? (
                <Loader />
              ) : (
                <StyledGridComp
                  rows={rowData}
                  columns={columns}
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  length={rowLength}
                ></StyledGridComp>
              )}
            </div>
          </div>
          {showConfirmModal && (
            <Dialog
              open={showConfirmModal}
              onClose={() => setShowConfirmModal(false)}
            >
              <div
                style={{
                  width: "400px",
                  padding: "20px",
                }}
              >
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Delete Dispensation Detail
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Are you sure you want to delete this detail ?
                </Typography>
              </div>
              <DialogActions>
                <button
                  className="create-btn"
                  style={{ width: "120px" }}
                  onClick={handleDelete}
                >
                  Yes
                </button>
                <button
                  className="create-btn-outlined"
                  style={{ width: "120px" }}
                  onClick={() => setShowConfirmModal(false)}
                >
                  No
                </button>
              </DialogActions>
            </Dialog>
          )}
        </div>
      )}
    </>
  );
};

export default AddUpdateDispensationDetail;
